import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[dHoverDIAN]',
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()'
  }
})
export class DHoverDirective {

  private el: HTMLInputElement;
  private imgSrcBefore: string;
  
	@Input('dHoverDIAN') imgSrc: string;

	/**
	* @constructor
	* @param {ElementRef} elementRef
	*/
  	constructor(
  		private elementRef: ElementRef
  	) { 
  		this.el = this.elementRef.nativeElement;
      this.imgSrcBefore = this.el.src;
  	}

    /**
    * @desc Funcion para cambiar la imagen al lanzar el evento hover
    */
    public onMouseEnter(): void { 
      //Obtengo las clases del elemento y busco la de desaturar que pone la imagen a blanco y negro cuando el boton debe de estar deshabilitado
      let classesElement = this.el.className;
      if (!(classesElement.indexOf('desaturar-img') > -1)) {
        this.el.src = this.imgSrc;
      }
    }

    /**
    * @desc Funcion para cambiar la imagen al lanzar el evento mouse leave
    */    
    public onMouseLeave(): void {
      this.el.src = this.imgSrcBefore;
    }

}



// WEBPACK FOOTER //
// D:/350/ng_ingreso_retefuente350/ReteFuente350Ingreso/src/app/directives/dhover.directive.ts